var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockAndKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2602_74370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5 72H13.5C6.0435 72 0 65.9565 0 58.5V13.5C0 6.0435 6.0435 0 13.5 0H58.5C65.9565 0 72 6.0435 72 13.5V58.5C72 65.9565 65.9565 72 58.5 72Z",
    fill: "#FFE6E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6257 28.5008H43.5007V25.5015C43.5007 21.3637 40.1347 18 35.9992 18C31.8637 18 28.5 21.3638 28.5 25.4993V28.4985H27.375C25.5142 28.4985 24 30.0128 24 31.8735V44.6243C24 46.485 25.5142 47.9993 27.375 47.9993H38.0265C38.85 46.2308 40.6657 45 42.7492 45H47.985C48.0007 44.8808 48.0007 44.7458 48.0007 44.6243V31.8735C48.0007 30.015 46.4842 28.5008 44.6257 28.5008ZM31.4992 28.5008V25.5015C31.4992 23.0197 33.5175 21.0015 35.9992 21.0015C38.481 21.0015 40.4992 23.0197 40.4992 25.5015V28.5008H31.4992Z",
    fill: "#FC573B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0007 45C54.0477 45 52.3985 46.2578 51.7775 47.9993H43.25C42.0103 47.9993 41 49.0095 41 50.2493V52.4993C41 53.3295 41.6705 54 42.5007 54C43.331 54 44.0015 53.3273 44.0015 52.4993V50.9985H51.7775C52.3985 52.7423 54.0477 54 56.0007 54C58.4825 54 60.5007 51.9818 60.5007 49.5C60.5007 47.0182 58.4825 45 56.0007 45ZM56.0007 51.0007C55.1727 51.0007 54.5 50.328 54.5 49.5C54.5 48.672 55.1727 47.9993 56.0007 47.9993C56.8287 47.9993 57.5015 48.672 57.5015 49.5C57.5015 50.328 56.8287 51.0007 56.0007 51.0007Z",
    fill: "#FD907E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2602_74370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockAndKey);
export default __webpack_public_path__ + "static/media/LockAndKey.21a1ec97d9276a390649714acf521cf3.svg";
export { ForwardRef as ReactComponent };